import React from 'react';
import { ErrorPage } from '../../components/common/page/ErrorPage';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';

export const ForbiddenPage = () => {
    useDocumentTitle('Forbidden');
    return (
        <ErrorPage
            code="403"
            title="Forbidden"
            description="You do not have permission to view this resource.">
            <div className="forbidden-icon text-center">
                <span className="fa-stack fa-5x w-100 mb-3">
                    <i className="fad fa-eye fa-stack-1x text-muted" />
                    <i className="fal fa-ban fa-stack-2x text-primary" />
                </span>
            </div>
        </ErrorPage>
    );
};
